"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = compareLowerCase;
var _toTurkishLowerCase = _interopRequireDefault(require("./toTurkishLowerCase"));
function convertLowerCaseTurkishToEnglish(string) {
  string = (0, _toTurkishLowerCase.default)(string);
  return string.replace(/[çğıöşü]/g, function (match) {
    switch (match) {
      case 'ç':
        return 'c';
      case 'ğ':
        return 'g';
      case 'ı':
        return 'i';
      case 'ö':
        return 'o';
      case 'ş':
        return 's';
      case 'ü':
        return 'u';
      default:
        return match;
    }
  });
}
function compareLowerCase(input, source, returnIndex) {
  var index = convertLowerCaseTurkishToEnglish(source).indexOf(convertLowerCaseTurkishToEnglish(input));
  return returnIndex ? index : index >= 0;
}